<template>
    <div class="has-logo">
        <logo :collapse="isCollapse" />
        <el-scrollbar wrap-class="scrollbar-wrapper">
            <el-menu
                :default-active="activeMenu"
                :collapse="isCollapse"
                :background-color="variables.menuBg"
                :text-color="variables.menuText"
                :active-text-color="variables.menuActiveText"
                :unique-opened="false"
                :collapse-transition="false"
                mode="vertical"
                @open="openSubMenu">
                <sidebar-item v-for="route in permission_routers" :key="route.path" style="position:static" :item="route" :base-path="route.path" :is-admin-menu="isAdminMenu" />
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<script>
import Logo from './Logo';
import { mapGetters } from 'vuex';
import SidebarItem from './SidebarItem';
import variables from '@/styles/variables.scss';

export default {
    components: { SidebarItem, Logo },
    computed: {
        ...mapGetters([
            'permission_routers',
            'sidebar',
            "isAdminMenu"
        ]),
        activeMenu() {
            const route = this.$route;
            const { meta, path } = route;
            // if set path, the sidebar will highlight the path you set
            if(meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },
        variables() {
            return variables;
        },
        isCollapse() {
            // return false;
            return !this.sidebar.opened;
        }
    },
    methods: {
        findRoute(path, routes) {
            var result = null;
            for(const route of routes) {
                if(route.path == path) {
                    result = route;
                    break;
                }else {
                    const temp = this.findRoute(path, route.children || []);
                    if(temp) {
                        result = temp;
                        break;
                    }
                }
            }
            return result;
        },
        openSubMenu(index, indexPath) {
            var result = this.findRoute(index, this.permission_routers);
            if(result && result.path === '/engineer') {
                setTimeout(() => {
                    const elObj = this.$el.querySelector("#menu" + result.path.substr(1) + (result.children.length - 1)); // 获取当前展开最后一个子元素
                    if(elObj) {
                        elObj.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 350);
            }
        }
    }
};
</script>
